import { Cancel, Circle, PauseCircle } from "@mui/icons-material";
import { SxProps, Typography } from "@mui/material";
import { CompletedStatusAnimation } from "src/assets/animations";
import { StatusChangedDialogContent } from "src/components";
import { CommentSubject, TASK_ITEM_STATUSES, TaskItemStatus } from "src/constants";

interface IProps {
  taskItemGuid: string;
  status: TaskItemStatus;
  onDone: () => void;
}

const TaskItemStatusChangedDialogContent = (props: IProps) => {
  function getIcon() {
    const iconSxProps: SxProps = {
      color: TASK_ITEM_STATUSES.find((x) => x.id === props.status)!.color,
      width: 100,
      height: 100,
    };

    switch (props.status) {
      case TaskItemStatus.Completed:
        return <CompletedStatusAnimation />;
      case TaskItemStatus.Paused:
        return <PauseCircle sx={iconSxProps} />;
      case TaskItemStatus.Cancelled:
        return <Cancel sx={iconSxProps} />;
      default:
        return <Circle sx={iconSxProps} />;
    }
  }

  function getContentBody() {
    switch (props.status) {
      case TaskItemStatus.Completed:
        return `Congratulations! You've marked this task ${TASK_ITEM_STATUSES.find(
          (x) => x.id === props.status
        )!.name.toUpperCase()}.`;
      default:
        return `You've marked this task ${TASK_ITEM_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}.`;
    }
  }

  return (
    <StatusChangedDialogContent
      icon={getIcon()}
      title={TASK_ITEM_STATUSES.find((x) => x.id === props.status)!.name.toUpperCase()}
      content={
        <Typography>
          {getContentBody()}
          <br />
          Please enter a comment with reasons for the change of status.
        </Typography>
      }
      commentSubjectType={CommentSubject.TaskItem}
      commentSubjectGuid={props.taskItemGuid}
      onDone={props.onDone}
    />
  );
};

export { TaskItemStatusChangedDialogContent };
